// extracted by mini-css-extract-plugin
module.exports = {"materials":"Materials_materials__zEi_s","content":"Materials_content__rTyf6","list":"Materials_list__Y3muq","title":"Materials_title__RCQoG"};